import { styled } from '@mui/system';
import { Chip, Divider, Typography, IconButton } from '@mui/material';

export const SubComponentContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'start',
  gap: 16,
  zIndex: '1000'
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  margin: '4px 3px',
  padding: '12px 0',
  borderRadius: 6,
  lineHeight: 32,
  height: 32,
  minHeight: 32,
  '& .MuiChip-label': {
    display: 'flex',
    alignItems: 'center',
    maxHeight: 32,
    '& svg': {
      fontSize: '1.5rem',
      cursor: 'pointer',
      color: '#878787',
      marginLeft: theme.spacing(1)
    }
  },
  '& .MuiChip-deleteIcon': {
    fontSize: 22
  }
}));

export const FullScreenOverlay = styled('div')(() => ({
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100vh',
  background: 'rgba(0, 0, 0, 0.5)',
  zIndex: '1000',
  display: 'flex',
  flexDirection: 'column'
}));

export const OverlayContent = styled('div')(() => ({
  background: '#fff',
  height: '100%',
  overflowY: 'auto',
  position: 'relative',
  padding: '16px'
}));

export const ShipmentArrowButton = styled('div')(() => ({
  display: 'flex',
  flex: '1',
  justifyContent: 'space-between',
  alignItems: 'center'
}));

export const MobileFilterPreloader = styled('div')(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  backgroundColor: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const MobileSelectorTitle = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  margin: '0 15px'
}));

export const SelectorCloseButton = styled(IconButton)(() => ({
  position: 'absolute',
  left: 0
}));

export const SelectorTitleText = styled(Typography)(() => ({
  flexGrow: 1,
  textAlign: 'center',
  padding: '20px'
}));

export const FilterSearchArea = styled('div')(() => ({
  margin: '15px',
  paddingBottom: '40px'
}));

export const FilterSearchInfo = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  margin: '10px 0'
}));

export const MobileFilterApplyBtn = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  position: 'fixed',
  width: '100%',
  height: 72,
  margin: '35px',
  top: 200,
  left: 0
}));

export const FilterDivider = styled(Divider)(() => ({
  padding: '10px 0',
  marginBottom: '20px'
}));
